import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import startupConfig from '../../lib/startupConfig';
import selectors from './selectors';
import actions from './actions';

interface StartupConfigProps {
  children: React.ReactNode;
}

const StartupConfig = ({ children }: StartupConfigProps) => {
  const configuration = useSelector(selectors.selectConfiguration);
  const isConfigurationSet = useSelector(selectors.selectIsConfigurationSet);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (isConfigurationSet) {
      startupConfig.set(configuration);
    } else {
      dispatch(actions.getStartupConfig());
    }
  }, [isConfigurationSet, configuration]);

  return isConfigurationSet ? <>{children}</> : null;
};

export default StartupConfig;
